<template>
  <div>
    <b-row class="mb-1 mt-2">
      <b-col md="2 d-flex align-items-center">
        <span class="target-audience-text">Target Audience</span>
      </b-col>

      <b-col md="10">
        <validation-provider
          #default="{ errors }"
          name="campaign text"
          rules="required"
        >
          <div class="demo-inline-spacing">
            <b-form-radio
              class="mt-0"
              v-model="selectedTarget"
              plain
              name="target-radio"
              value="setup"
              @change="onChange"
            >
              Manual
            </b-form-radio>
            <!-- <b-form-radio
              v-model="selectedTarget"
              plain
              name="target-radio"
              value="upload"
              @change="onChange"
            >
              Upload Target Audience
            </b-form-radio> -->
            <b-form-radio
              class="mt-0"
              v-model="selectedTarget"
              plain
              name="target-radio"
              value="visualization"
              @change="onChange"
            >
              By Data Visualization
            </b-form-radio>
          </div>
          <small class="text-danger">{{ errors[0] }}</small>
        </validation-provider>
      </b-col>
    </b-row>

    <b-row>
      <!-- UPLOAD CSV -->
      <!-- END UPLOAD CSV -->

      <!-- Visualization -->
      <b-col v-if="selectedTarget === 'visualization'" md="12">
        <b-row>
          <b-col md="12">
            <!-- MAP -->
            <!-- <b-container
              v-if="campaignForm.campaigntype.type === 'lba'"
              class="mb-2"
            >
              <b-row>
                <b-col md="12">
                  <div style="position: absolute;z-index: 999;right: 8px;">
                    <b-button
                      variant="primary"
                      size="sm"
                      class="mt-1 w-100"
                      @click="activePolyline"
                    >
                      {{ apoly }}
                    </b-button>
                    <br />
                    <b-button
                      variant="primary"
                      size="sm"
                      class="mt-1 w-100"
                      @click="clearPolyline"
                    >
                      Clear Polyline
                    </b-button>
                  </div>
                  <l-map
                    ref="map"
                    style="height: 186px; width: 100%;border: 1px solid #DCDCE3;border-radius: 8px;"
                    :zoom="zoom"
                    :center="center"
                    @update:zoom="zoomUpdated"
                    @update:center="centerUpdated"
                    @update:bounds="boundsUpdated"
                    @click="addPolyline"
                  >
                    <l-tile-layer :url="url"></l-tile-layer>
                    <l-draw-toolbar position="topright"></l-draw-toolbar>
                    <l-polygon
                      :lat-lngs="polygon.latlngs"
                      :color="polygon.color"
                    ></l-polygon>
                    <l-circle
                      :lat-lng="circle.center"
                      :radius="circle.radius"
                      :color="circle.color"
                    />
                  </l-map>
                </b-col>
              </b-row>
            </b-container> -->
            <!-- End MAP -->
          </b-col>
          <b-col md="12">
            <div class="title-SDAAudienceExploration">
              <h2>SDA AUDIENCE EXPLORATION</h2>
            </div>
          </b-col>
          <b-col
            md="12"
            style="display: flex; justify-content: center; align-items: center;"
            class="my-1"
          >
            <!-- Using modifiers -->
            <b-button
              class="btnTargetAudience m-0"
              :class="[
                selectedTargetVisualization === 'Administrative'
                  ? 'activeBtn'
                  : '',
              ]"
              v-model="selectedTargetVisualization"
              value="Administrative"
              @click="onChangeVisualization('Administrative')"
              style="border-radius: 50px;"
            >
              Administrative <br />
              Area
            </b-button>
            <b-button
              class="btnTargetAudience m-0"
              :class="[
                selectedTargetVisualization === 'Users' ? 'activeBtn' : '',
              ]"
              v-model="selectedTargetVisualization"
              value="Users"
              @click="onChangeVisualization('Users')"
              style="border-radius: 50px;"
            >
              User Defined <br />
              Area
            </b-button>
            <div class="line"></div>
          </b-col>
          <b-col
            v-if="selectedTargetVisualization === 'Administrative'"
            md="12"
          >
            <b-col md="12" class="vh-100 mb-2">
              <iframe
                :src="urlDSVAdministrative"
                id="iFrame"
                align="center"
                width="100%"
                height="100%"
                frameborder="0"
                style="border:0"
                allowfullscreen
              ></iframe>
            </b-col>
          </b-col>
          <b-col v-if="selectedTargetVisualization === 'Users'" md="12">
            <!-- MAP CIRCLE -->
            <b-container>
              <b-row>
                <b-col md="12">
                  <div style="position: absolute;z-index: 999;right: 8px;z-index: 2;">
                    <b-button
                      variant="primary"
                      size="sm"
                      class="mt-1 w-100"
                      @click="activePolylineCircle"
                    >
                      {{ apolyCircle }}
                    </b-button>
                    <br />
                    <b-button
                      variant="primary"
                      size="sm"
                      class="mt-1 w-100"
                      @click="clearPolylineCircle"
                    >
                      Clear Pin Point
                    </b-button>
                  </div>
                  <l-map
                    ref="map"
                    style="height: 186px; width: 100%;border: 1px solid #DCDCE3;border-radius: 8px;z-index: 1;"
                    :zoom="zoomCircle"
                    :center="centerCircle"
                    @update:zoom="zoomUpdatedCircle"
                    @update:center="centerUpdatedCircle"
                    @update:bounds="boundsUpdatedCircle"
                    @click="addPolylineCircle"
                  >
                    <l-tile-layer :url="url"></l-tile-layer>
                    <!-- <l-draw-toolbar position="topright"></l-draw-toolbar> -->
                    <!-- <l-polygon
                      :lat-lngs="polygon.latlngs"
                      :color="polygon.color"
                    ></l-polygon> -->
                    <l-circle
                      :lat-lng="circle.center"
                      :radius="circle.radius"
                      :color="circle.color"
                    />
                  </l-map>
                </b-col>
              </b-row>
            </b-container>
            <!-- End MAP CIRCLE -->

            <!-- Input Lat, Leng and Radius -->
            <b-container class="mt-1">
              <b-row>
                <b-col md="4">
                  <label>Latitude</label>
                  <b-form-group>
                    <b-form-input
                      id="latitude"
                      placeholder="Latitude"
                      rows="3"
                      v-model="circle.center[0]"
                      disabled
                    />
                  </b-form-group>
                </b-col>
                <b-col md="4">
                  <label>Longtitude</label>
                  <b-form-group>
                    <b-form-input
                      id="longitude"
                      placeholder="Longitude"
                      rows="3"
                      v-model="circle.center[1]"
                      disabled
                    />
                  </b-form-group>
                </b-col>
                <b-col md="4">
                  <label>Radius (in Meters)</label>
                  <b-form-group>
                    <b-form-input
                      id="radius"
                      placeholder="Radius"
                      rows="3"
                      v-model="circle.radius"
                      @input="onChangeRadius"
                    />
                  </b-form-group>
                </b-col>
              </b-row>
            </b-container>
            <!-- End Input Lat, Leng and Radius -->

            <b-col md="12" class="vh-100 mb-2">
              <iframe
                :src="frameUsersDSV"
                id="iFrame"
                align="center"
                width="100%"
                height="100%"
                frameborder="0"
                style="border:0"
                allowfullscreen
              ></iframe>
            </b-col>
          </b-col>
          <b-col md="12">
            <!-- <validation-provider
              #default="{ errors }"
              name="campaign name"
              rules="required"
            > -->
              <b-button v-on:click="generateDataVisual">
                <p class="mb-0" v-if="loadingGetDataVisual === true">
                  Loading
                </p>
                <p class="mb-0" v-if="loadingGetDataVisual === false">
                  Generate Data Visual
                </p>
              </b-button>
              <p v-if="statusDSV.status && statusDSV.data.length > 0" class="mb-0">Generate Success</p>
              <p v-if="statusDSV.status && statusDSV.data.length === 0" class="mb-0 text-warning">Unsuccessfully generate, please click again</p>
              <p v-if="statusDSV.status === false" style="color: red;" class="mb-0">{{statusDSV.message.includes('timeout') === 'true' ? "Generate Timeout. (Generate Again)" : "Generate Failed"}}</p>
            <!-- </validation-provider> -->
          </b-col>
        </b-row>
        <!-- <b-row>
          <b-col md="6">
            <b-form-group>
              <label
                class="label-note"
                for="msisdn"
                data-note="(Max upload 1.000.000 MSISDN)"
              >
                Upload MSISDN List
              </label>
              <validation-provider
                #default="{ errors }"
                name="msisdn"
                rules="required"
              >
                <b-form-file
                  id="msisdn"
                  ref="uploadMsisdn"
                  name="msisdn"
                  accept=".csv"
                  placeholder="Please upload your .csv MSISDN in single row format"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>
        </b-row> -->
      </b-col>
      <!-- End Visualization -->

      <!-- Manual -->
      <b-col v-if="selectedTarget === 'setup'" md="12">
        <b-row>
          <b-col md="12">
            <div class="title-segmentsSelection">
              <h2>SEGMENTS SELECTION</h2>
            </div>

            <!-- Input Gender and Age -->
            <b-row>
              <b-col md="3" class="px-2">
                <span>Gender</span>
              </b-col>
              <b-col md="2">
                <b-form-group>
                  <b-form-checkbox-group
                    id="checkbox-gender"
                    v-model="campaignForm.targeting.gender"
                    :options="optionsGender"
                    name="gender-box"
                  />
                </b-form-group>
              </b-col>
            </b-row>
            <b-row class="mb-1">
              <b-col md="3" class="px-2">
                <span>Age</span>
              </b-col>
              <b-col md="2">
                <b-form-group class="mb-0">
                  <v-select
                    id="min-age"
                    v-model="campaignForm.targeting.min_age"
                    :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                    :options="age"
                    :reduce="(text) => text.value"
                    label="text"
                    placeholder="From"
                    @input="listMaxAge"
                  />
                </b-form-group>
              </b-col>
              <b-col md="2">
                <b-form-group class="mb-0">
                  <v-select
                    id="max-age"
                    v-model="campaignForm.targeting.max_age"
                    :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                    :options="maxAge"
                    :reduce="(text) => text.value"
                    label="text"
                    placeholder="To"
                  />
                </b-form-group>
              </b-col>
            </b-row>
            <!-- End Input Gender and Age -->

            <!-- Input Prov, Kab, and Kec -->
            <b-container>
              <b-row>
                <b-col md="4">
                  <label>Province</label>
                  <validation-observer ref="campaignRulesTargeting" tag="form">
                    <b-form-group>
                      <validation-provider
                        #default="{ errors }"
                        name="location"
                        rules="required"
                      >
                        <div class="d-flex">
                          <v-select
                            id="location"
                            ref="vselectLocation"
                            v-model="provinceSelected"
                            :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                            :options="optionsProvince"
                            :reduce="(text) => text"
                            label="name"
                            :state="errors.length > 0 ? false : null"
                            placeholder="Type Location"
                            class="width-400"
                            autocomplete="locations"
                            @input="inputLocationProvince"
                          >
                          </v-select>
                        </div>
                        <small class="text-danger">{{ errors[0] }}</small>
                      </validation-provider>
                    </b-form-group>
                  </validation-observer>
                </b-col>
                <b-col md="4">
                  <label>Kabupaten</label>
                  <b-form-group>
                    <!-- <validation-provider
                      #default="{ errors }"
                      name="location"
                      rules="required"
                    > -->
                      <div class="d-flex">
                        <v-select
                          id="location"
                          ref="vselectLocation"
                          v-model="kabupatenSelected"
                          :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                          :options="optionsKabupaten"
                          :reduce="(text) => text"
                          label="name"
                          placeholder="Type Location"
                          class="width-400"
                          autocomplete="locations"
                          @input="inputLocationKabupaten"
                        >
                        </v-select>
                      </div>
                      <!-- <small class="text-danger">{{ errors[0] }}</small> -->
                    <!-- </validation-provider> -->
                  </b-form-group>
                </b-col>
                <b-col md="4">
                  <label>Kecamatan</label>
                  <b-form-group>
                    <!-- <validation-provider
                      #default="{ errors }"
                      name="location"
                      rules="required"
                    > -->
                      <div class="d-flex">
                        <v-select
                          id="location"
                          ref="vselectLocation"
                          v-model="kecamatanSelected"
                          :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                          :options="optionsKecamatan"
                          :reduce="(text) => text"
                          label="name"
                          placeholder="Type Location"
                          class="width-400"
                          autocomplete="locations"
                          @input="inputLocationKecamatan"
                        >
                        </v-select>
                      </div>
                      <!-- <small class="text-danger">{{ errors[0] }}</small> -->
                    <!-- </validation-provider> -->
                  </b-form-group>
                </b-col>
              </b-row>
            </b-container>
            <!-- End Input Prov, Kab, and Kec -->

            <!-- MAP -->
            <!-- <b-container v-if="campaignForm.campaigntype.type === 'lba'">
              <b-row>
                <b-col md="12">
                  <div style="position: absolute;z-index: 999;right: 8px;">
                    <b-button
                      variant="primary"
                      size="sm"
                      class="mt-1 w-100"
                      @click="activePolyline"
                    >
                      {{ apoly }}
                    </b-button>
                    <br />
                    <b-button
                      variant="primary"
                      size="sm"
                      class="mt-1 w-100"
                      @click="clearPolyline"
                    >
                      Clear Polyline
                    </b-button>
                  </div>
                  <l-map
                    ref="map"
                    style="height: 186px; width: 100%;border: 1px solid #DCDCE3;border-radius: 8px;"
                    :zoom="zoom"
                    :center="center"
                    @update:zoom="zoomUpdated"
                    @update:center="centerUpdated"
                    @update:bounds="boundsUpdated"
                    @click="addPolyline"
                  >
                    <l-tile-layer :url="url"></l-tile-layer>
                    <l-polygon
                      :lat-lngs="polygon.latlngs"
                      :color="polygon.color"
                    ></l-polygon>
                  </l-map>
                </b-col>
              </b-row>
            </b-container> -->
            <!-- End MAP -->

            <!-- Input Segments Selection -->
            <b-container class="mt-1 mb-2">
              <b-row>
                <b-col md="9" class="d-flex flex-column justify-content-end">
                  <b-row>
                    <b-col md="3">
                      <p
                        class="lable-segmentsSelection"
                        style="background: #FFCB05"
                      >
                        User Persona
                      </p>
                      <b-form-group>
                        <div class="d-flex">
                          <v-select
                            id="userpersona"
                            ref="vselectUserpersona"
                            v-model="userPersonaSelection"
                            multiple
                            :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                            :options="optionsUserPersona"
                            :reduce="(text) => text"
                            label="userPersonName"
                            placeholder="User Persona"
                            class="width-400"
                            @input="inputUserPersona"
                          >
                          </v-select>
                        </div>
                      </b-form-group>
                    </b-col>
                    <b-col md="5">
                      <p
                        class="lable-segmentsSelection"
                        style="background: #3AD277"
                      >
                        Engagement by App
                      </p>
                      <b-form-group>
                        <div class="d-flex">
                          <b-col md="6" class="pl-0">
                            <div class="d-flex">
                              <v-select
                                id="app"
                                ref="vselectApp"
                                v-model="appSelection"
                                multiple
                                :dir="
                                  $store.state.appConfig.isRTL ? 'rtl' : 'ltr'
                                "
                                :options="optionsApp"
                                :reduce="(text) => text"
                                label="appName"
                                placeholder="App"
                                class="width-400"
                                @input="inputApp"
                              >
                              </v-select>
                            </div>
                          </b-col>
                          <b-col md="6" class="pr-0">
                            <div class="d-flex">
                              <v-select
                                id="engagementbyapp"
                                ref="vselectEngagementbyApp"
                                v-model="engagementbyAppSelection"
                                multiple
                                :dir="
                                  $store.state.appConfig.isRTL ? 'rtl' : 'ltr'
                                "
                                :options="optionsEngagementbyApp"
                                :reduce="(text) => text"
                                label="engagementbyAppName"
                                placeholder="Engagement by App"
                                class="width-400"
                                @input="inputEngagementbyApp"
                              >
                              </v-select>
                            </div>
                          </b-col>
                        </div>
                      </b-form-group>
                    </b-col>
                    <b-col md="4">
                      <p
                        class="lable-segmentsSelection"
                        style="background: #32BCAD"
                      >
                        Visitor - Traveler Clasification
                      </p>
                      <b-form-group>
                        <div class="d-flex">
                          <v-select
                            id="visitor"
                            ref="vselectVisitor"
                            v-model="visitorSelection"
                            multiple
                            :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                            :options="optionsVisitor"
                            :reduce="(text) => text"
                            label="visitorName"
                            placeholder="Visitor - Traveler Clasification"
                            class="width-400"
                            @input="inputVisitor"
                          >
                          </v-select>
                        </div>
                      </b-form-group>
                    </b-col>
                    <b-col md="3">
                      <p
                        class="lable-segmentsSelection"
                        style="background: #C6168D"
                      >
                        Commuter
                      </p>
                      <b-form-group class="mb-0">
                        <div class="d-flex">
                          <v-select
                            id="commuter"
                            ref="vselectCommuter"
                            v-model="commuterSelection"
                            multiple
                            :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                            :options="optionsCommuter"
                            :reduce="(text) => text"
                            label="commuterName"
                            placeholder="Commuter"
                            class="width-400"
                            @input="inputCommuter"
                          >
                          </v-select>
                        </div>
                      </b-form-group>
                    </b-col>
                    <b-col md="5">
                      <p
                        class="lable-segmentsSelection"
                        style="background: #EC008C"
                      >
                        Neigbourhood Tier
                      </p>
                      <b-form-group class="mb-0">
                        <div class="d-flex">
                          <v-select
                            id="neigbourhoodtier"
                            ref="vselectNeigbourhoodTier"
                            v-model="neigbourhoodTierSelection"
                            multiple
                            :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                            :options="optionsNeigbourhoodTier"
                            :reduce="(text) => text"
                            label="neigbourhoodTierName"
                            placeholder="Neigbourhood Tier"
                            class="width-400"
                            @input="inputNeigbourhoodTier"
                          >
                          </v-select>
                        </div>
                      </b-form-group>
                    </b-col>
                    <b-col md="4">
                      <p
                        class="lable-segmentsSelection"
                        style="background: #32BCAD"
                      >
                        POI Category
                      </p>
                      <b-form-group class="mb-0">
                        <div class="d-flex">
                          <v-select
                            id="poicategory"
                            ref="vselectPOICategory"
                            v-model="poiCategorySelection"
                            multiple
                            :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                            :options="optionsPOICategory"
                            :reduce="(text) => text"
                            label="poiCategoryName"
                            placeholder="POI Category"
                            class="width-400"
                            @input="inputPOICategory"
                          >
                          </v-select>
                        </div>
                      </b-form-group>
                    </b-col>
                  </b-row>
                </b-col>
                <b-col md="1" class="d-flex flex-column justify-content-end">
                  <div class="button-countingAudience w-100">
                    <b-button
                      size="sm"
                      class="w-100"
                      @click="setForcastedIOH"
                      style="padding: 25px 0;background: rgb(236, 0, 140) !important;border: none;"
                    >
                      Check >
                    </b-button>
                  </div>
                </b-col>
                <b-col md="2" class="d-flex flex-column justify-content-end">
                  <div class="text-center">
                    <img
                      id="target-subs"
                      class="img-fluid"
                      :src="require('@/assets/svg/TargetSubs.svg')"
                      alt="Target Subs"
                    />
                  </div>
                  <div class="totalSubsSelected">
                    <p class="titleSubs">TOTAL SUBSCRIBED SELECTED</p>
                    <p class="totalSubs" v-if="accessForecastedIOH">
                      {{ formatPrice(dataForcasted) }}
                    </p>
                    <p class="totalSubs" v-if="!accessForecastedIOH">
                      Counting...
                    </p>
                  </div>
                  <span style="color: red; font-size: 10px; text-align: center;">{{dataForcastedStatus}}</span>
                </b-col>
              </b-row>
            </b-container>
            <!-- End Input Segment Selection -->

            <!-- <b-row>
              <b-col md="4">
                <span>Interest</span>
              </b-col>
              <b-col md="8">
                <b-form-group>
                  <validation-provider
                    #default="{ errors }"
                    name="interest"
                    rules="required"
                  >
                    <div class="d-flex">
                      <v-select
                        id="interest"
                        ref="vselectInterest"
                        v-model="campaignForm.targeting.interest"
                        multiple
                        :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                        :options="optionsInterest"
                        :reduce="text => text.value"
                        label="text"
                        :state="errors.length > 0 ? false:null"
                        placeholder="Type Interest"
                        :selectable="() => (campaignForm.targeting.interest.toString() === 'ALL') ? false : true"
                        class="width-400"
                        @input="inputInterest"
                      >
                        <template #list-header>
                          <li style="text-align: left; padding: 1rem;">
                            <b-button
                              v-if="!allInterest || campaignForm.targeting.interest===[]"
                              size="sm"
                              block
                              variant="primary"
                              class="h-100"
                              @click="selectAllInterest"
                            >
                              Select All
                            </b-button>
                            <b-button
                              v-if="allInterest"
                              size="sm"
                              block
                              variant="primary"
                              class="h-100"
                              @click="UnselectAllInterest"
                            >
                              Deselect All
                            </b-button>
                          </li>
                        </template>
                      </v-select>
                    </div>
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
            </b-row>
            <b-row>
              <b-col md="4">
                <span>Devices</span>
              </b-col>
              <b-col md="8">
                <b-form-group>
                  <validation-provider
                    #default="{ errors }"
                    name="device"
                    rules="required"
                  >
                    <b-form-checkbox-group
                      v-if="campaignForm.channel_id!==3"
                      id="checkbox-device"
                      v-model="campaignForm.targeting.device"
                      :options="optionsDevice"
                      name="device-box"
                    />
                    <b-form-checkbox-group
                      v-if="(campaignForm.channel_id===3 && campaignForm.method_id!==2)"
                      id="checkbox-device"
                      v-model="campaignForm.targeting.device"
                      :options="optionsDevice"
                      name="device-box"
                    />
                    <b-form-checkbox-group
                      v-if="(campaignForm.channel_id===3 && campaignForm.method_id===2)"
                      id="checkbox-device"
                      v-model="campaignForm.targeting.device"
                      :options="optionsDeviceEx"
                      name="device-box"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
            </b-row> -->

            <!-- <b-row>
              <b-col md="10" class="mb-1">
                <b-form-input
                  id="add-interest"
                  v-model="addInterest"
                  placeholder="Add Interest"
                  @input="setInterest"
                />
              </b-col>
              <b-col md="2">
                <b-button class="btn-addInterest">
                  Add
                </b-button>
              </b-col>
            </b-row>
            <b-row>
              <b-col md="12">
                <v-select
                  v-model="campaignForm.targeting.interest"
                  multiple
                  :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                  :reduce="text => text.value"
                  label="text"
                  placeholder="Type Interest"
                  class="w-100"
                >
                  <template #list-header>
                    <li style="text-align: left; padding: 1rem;">
                      <b-button
                        v-if="!allInterest || campaignForm.targeting.interest===[]"
                        size="sm"
                        block
                        variant="primary"
                        class="h-100"
                        @click="selectAllInterest"
                      >
                        Select All
                      </b-button>
                      <b-button
                        v-if="allInterest"
                        size="sm"
                        block
                        variant="primary"
                        class="h-100"
                        @click="UnselectAllInterest"
                      >
                        Deselect All
                      </b-button>
                    </li>
                  </template>
                </v-select>
              </b-col>
            </b-row> -->
          </b-col>
        </b-row>
      </b-col>
      <!-- End Manual -->
    </b-row>
  </div>
</template>

<script>
import {
  BRow,
  BCol,
  BFormGroup,
  BFormInput,
  BFormRadio,
  BFormFile,
  BFormCheckboxGroup,
  BButton,
  BCard,
  BContainer,
} from "bootstrap-vue";
import { ValidationProvider, ValidationObserver, extend } from "vee-validate";
import vSelect from "vue-select";
import { mapActions, mapGetters } from "vuex";
import axiosIns, { axiosInsNoEnc } from "@/libs/axios";

// Import Map
import "leaflet/dist/leaflet.css";
import { LMap, LTileLayer, LPolygon, LCircle } from "vue2-leaflet";

extend("number", (value) => {
  // if (value === '0') return true
  const val = parseInt(value.replace(/\./g, ""), 10);
  if (Number.isInteger(val) || val === 0) return true;
  return "Values must be numeric";
});

export default {
  components: {
    BRow,
    BCol,
    BFormGroup,
    BFormInput,
    BFormFile,
    BFormRadio,
    BFormCheckboxGroup,
    BCard,
    BContainer,
    ValidationProvider,
    vSelect,
    BButton,
    LMap,
    LTileLayer,
    LPolygon,
    LCircle,
    ValidationObserver,
  },
  data() {
    return {
      accessForecasted: true,
      accessForecastedIOH: true,
      listInterest: [],
      allInterest: false,
      allLocation: false,
      selectedTarget: "",
      selectedTargetVisualization: "Administrative",
      multipleLocation: true,
      disableLocation: false,
      age: [],
      maxAge: [],
      optionsGender: [
        { text: "Male", value: "MALE" },
        { text: "Female", value: "FEMALE" },
      ],
      optionsDevice: [
        { text: "Android", value: "ANDROID" },
        { text: "IOS", value: "IOS" },
      ],
      optionsDeviceEx: [{ text: "Android", value: "ANDROID" }],
      minArpu: "",
      maxArpu: "",
      apoly: "Active Drop Here",
      statusApoly: false,
      url: "https://{s}.tile.osm.org/{z}/{x}/{y}.png",
      zoom: 14,
      center: [-6.175268, 106.827844],
      bounds: null,
      polygon: {
        latlngs: [],
        color: "green",
      },

      zoomCircle: 14,
      centerCircle: [-6.175268, 106.827844],
      apolyCircle: "Pin Circle Here",
      statusApolyCircle: false,
      circle: {
        center: [-6.175268, 106.827844],
        radius: 1000,
        color: "red",
      },

      latitudeSelected: "",
      longitudeSelected: "",

      latitudeSelectedDSV: "",
      longitudeSelectedDSV: "",
      // url: "http://{s}.basemaps.cartocdn.com/light_all/{z}/{x}/{y}.png",
      // zoom: 18,
      // center: [-6.175268, 106.827844],
      // bounds: null

      // State Location
      optionsKabupaten: [],
      optionsKecamatan: [],
      provinceSelected: "",
      kabupatenSelected: "",
      kecamatanSelected: "",
      // End State Location

      // State Selection Segments
      userPersonaSelection: [],
      appSelection: [],
      engagementbyAppSelection: [],
      visitorSelection: [],
      commuterSelection: [],
      neigbourhoodTierSelection: [],
      poiCategorySelection: [],

      loadingGetDataVisual: false,
      frameUsersDSV: "",

      dataForcasted: 0,
      dataForcastedStatus: "",

      urlDSVUserDefine: process.env.VUE_APP_URL_DSV_USER_DEFINED_AREA,
      urlDSVAdministrative: process.env.VUE_APP_URL_DSV_ADMINISTRATIVE_AREA,
    };
  },
  computed: {
    ...mapGetters("campaign", {
      campaignForm: "getCampaignForm",
      forcastedAudience: "getForcastedAudience",
      forcastedAudienceIOH: "getForcastedAudienceIOH",
      statusDSV: 'getStatusDataDsv',
    }),
    ...mapGetters("datas", {
      optionsLocation: "getLocation",
      optionsProvince: "getDataProvinceSegment",
      optionsInterest: "getInterest",
      optionsUserPersona: "getDataUserPersonaSegment",
      optionsApp: "getDataAppSegment",
      optionsEngagementbyApp: "getDataEngagementbyAppSegment",
      optionsVisitor: "getDataVisitor",
      optionsCommuter: "getDataCommuter",
      optionsNeigbourhoodTier: "getDataNeigbourhoodTier",
      optionsPOICategory: "getDataPOICategory",
    }),
  },
  beforeMount() {
    this.listAge();
    this.listMaxAge(16);
    this.$store.state.campaign.statusDSV = [];
    this.$store.state.campaign.formCampaign.targeting.data_dsv = [];
  },
  mounted() {
    // eslint-disable-next-line arrow-parens
    // this.optionsUserPersona.map((x) => {
    //   // eslint-disable-next-line no-param-reassign
    //   x.item_data = `${x.personaName} (${x.rowdata}k)`
    //   return x
    // })
  },
  methods: {
    ...mapActions("campaign", [
      "setForcastedAudience",
      "setForcastedAudienceIOH",
      "setGetParamsDSV",
    ]),
    // setForecasted() {
    //   let channelId = this.$store.state.campaign.formCampaign.channel_id
    //   let dataTargetings = this.$store.state.campaign.formCampaign.targeting
    //   console.log(dataTargetings);
    //   this.accessForecasted = false
    // this.setForcastedAudience(channelId).then(() => {
    //   this.accessForecasted = true
    // })
    // },

    // Counting Forcasted
    setForcastedIOH() {
      this.$refs.campaignRulesTargeting.validate().then((res) => {
        if(res === true) {
          this.accessForecastedIOH = false;
          this.dataForcastedStatus = "";
          this.setForcastedAudienceIOH().then((res) => {
            this.dataForcasted = res;
            this.accessForecastedIOH = true;
          }).catch((err) => {
            this.accessForecastedIOH = true;
            this.dataForcasted = 0
            this.dataForcastedStatus = "Please Try Again : ( " + err.message + " )"
          });
        }
      })
    },
    // End Counting Forcaster

    listAge() {
      // eslint-disable-next-line no-plusplus
      for (let i = 0; i < 70; i++) {
        this.age[i] = {
          text: `${i + 16}`,
          value: i + 16,
        };
      }
    },
    formatPrice(value) {
      if (value === null || typeof value === "undefined") {
        return 0;
      }
      let val = (value / 1).toFixed(0).replace(".", ",");
      return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
    },
    listMaxAge(val) {
      // eslint-disable-next-line no-plusplus
      for (let i = 0; i < 70; i++) {
        this.maxAge[i] = {
          text: `${i + val}`,
          value: i + val,
        };
      }
    },
    onChange() {
      if (this.selectedTarget === "setup") {
        // this.$refs.uploadMsisdn.value = null
        this.campaignForm.targeting.type = "setup";
        this.campaignForm.upload_msisdn = null;
      } else if (this.selectedTarget === "visualization") {
        // this.$refs.uploadMsisdn.value = null
        this.campaignForm.targeting.type = "visualization";
        this.campaignForm.upload_msisdn = null;
      } else {
        this.campaignForm.targeting.type = "upload";
        this.campaignForm.targeting.min_age = "";
        this.campaignForm.targeting.max_age = "";
        this.campaignForm.targeting.gender = [];
        this.campaignForm.targeting.min_arpu = "";
        this.campaignForm.targeting.max_arpu = "";
        this.campaignForm.targeting.location = [];
        this.campaignForm.targeting.interest = [];
        this.campaignForm.targeting.device = [];
        // this.campaignForm.targeting.file = null
        this.campaignForm.targeting.cem_subs_ctgry = [];
        // this.forcastedAudience = 0
        // this.$store.state.formCampaign.forcastedAudience = 0
        this.$store.commit("campaign/SET_FOR_AUDIENCE", 0);
        this.setForcastedAudience();
      }
      this.$store.state.campaign.formCampaign.targeting.type = this.selectedTarget;
    },
    onChangeVisualization(props) {
      if (this.selectedTargetVisualization === "Administrative") {
        this.selectedTargetVisualization = props;
      } else {
        this.selectedTargetVisualization = props;
      }
    },
    onUpload(e) {
      const file = e.target.files[0];
      this.$store.state.campaign.formCampaign.msisdn_profiling = file;
    },
    inputInterest(val) {
      // console.log(val.length)
      if (val.length === 0) {
        this.allInterest = false;
      }
      this.$store.state.campaign.formCampaign.targeting.interest = val;
    },
    selectAllInterest() {
      // this.$store.state.campaign.formCampaign.targeting.interest = this.optionsInterest.map(item => item.value)
      this.$store.state.campaign.formCampaign.targeting.interest = ["ALL"];
      this.allInterest = true;
      this.$refs.vselectInterest.$emit("close");
    },
    UnselectAllInterest() {
      this.$store.state.campaign.formCampaign.targeting.interest = [];
      this.allInterest = false;
    },
    selectAllLocation() {
      this.$store.state.campaign.formCampaign.targeting.location = ["ALL"];
      // this.$store.state.campaign.formCampaign.targeting.location = this.optionsLocation.map(item => item.value)
      this.allLocation = true;
      this.$refs.vselectLocation.$emit("close");
    },
    UnselectAllLocation() {
      this.$store.state.campaign.formCampaign.targeting.location = [];
      this.allLocation = false;
    },
    numberWithoutCommas(x) {
      return x.toString().replace(/\./g, "");
    },
    setMinArpu(budget) {
      let bd = this.formatRupiah(budget);
      this.minArpu = bd;
      this.$store.state.campaign.formCampaign.targeting.min_arpu = this.numberWithoutCommas(
        this.minArpu
      );
    },
    setMaxArpu(budget) {
      let bd = this.formatRupiah(budget);
      this.maxArpu = bd;
      this.$store.state.campaign.formCampaign.targeting.max_arpu = this.numberWithoutCommas(
        this.maxArpu
      );
    },
    formatRupiah(angka, prefix) {
      let a = angka;
      if (angka.length > 1) {
        a = angka.replace(/^0/g, "");
      }
      let numberString = a.replace(/[^,\d]/g, "");
      let split = numberString.split(",");
      let sisa = split[0].length % 3;
      let rupiah = split[0].substr(0, sisa);
      let ribuan = split[0].substr(sisa).match(/\d{3}/gi);
      // console.log(angka, ang, split)
      if (ribuan) {
        let separator = sisa ? "." : "";
        rupiah += separator + ribuan.join(".");
      }

      rupiah = split[1] !== undefined ? `${rupiah},${split[1]}` : rupiah;
      // eslint-disable-next-line no-nested-ternary
      return prefix === undefined ? rupiah : rupiah ? `IDR. ${rupiah}` : "";
    },

    // MAP FUNCTION
    zoomUpdated(zoom) {
      this.zoom = zoom;
    },
    centerUpdated(center) {
      this.center = center;
    },
    boundsUpdated(bounds) {
      this.bounds = bounds;
    },
    addPolyline(event) {
      if (this.statusApoly) {
        this.polygon.latlngs.push(event.latlng);
        this.$store.state.campaign.formCampaign.targeting.polygons = this.polygon.latlngs;
      }
    },
    clearPolyline() {
      this.polygon.latlngs = [];
      this.$store.state.campaign.formCampaign.polygons.latlngs = [];
    },
    activePolyline() {
      if (this.statusApoly) {
        this.apoly = "Active Polyline";
        this.statusApoly = false;
      } else {
        this.apoly = "Inactive Polyline";
        this.statusApoly = true;
      }
    },
    // END MAP FUNCTION

    // MAP FUNCTION CIRCLE
    zoomUpdatedCircle(zoomCircle) {
      this.zoomCircle = zoomCircle;
    },
    centerUpdatedCircle(centerCircle) {
      this.centerCircle = centerCircle;
    },
    boundsUpdatedCircle(bounds) {
      this.bounds = bounds;
    },
    addPolylineCircle(event) {
      if (this.statusApolyCircle) {
        // this.circle.center = event.latlng.lat;
        // this.circle.center = event.latlng.lng;
        this.circle.center = [event.latlng.lat, event.latlng.lng];
        this.$store.state.campaign.formCampaign.targeting.circle.center = this.circle.center;
      }
      this.frameUsersDSV =
        `${process.env.VUE_APP_URL_DSV_USER_DEFINED_AREA}?params=%7B%22ds122.lat%22:` +
        event.latlng.lat.toString() +
        ",%22ds122.lng%22:" +
        event.latlng.lng.toString() +
        ",%22ds122.radius%22:" +
        this.circle.radius.toString() +
        "%7D";
    },
    clearPolylineCircle() {
      this.circle.center = [];
      // this.$store.state.campaign.formCampaign.polygons = []
    },
    activePolylineCircle() {
      if (this.statusApolyCircle) {
        this.apolyCircle = "Pin Point Here";
        this.statusApolyCircle = false;
      } else {
        this.apolyCircle = "Inactive Pin Point";
        this.statusApolyCircle = true;
      }
    },
    // END MAP FUNCTION CIRCLE

    // INPUT LOCATION PROVINCE
    inputLocationProvince() {
      this.$store.state.campaign.formCampaign.targeting.locationProvince = ""
      this.$store.state.campaign.formCampaign.targeting.locationKabupaten = ""
      this.$store.state.campaign.formCampaign.targeting.locationKecamatan = ""
      this.kabupatenSelected = ""
      this.kecamatanSelected = ""
      this.optionsKecamatan = []
      this.optionsKabupaten = []
      this.dataForcasted = 0
      const provID = this.provinceSelected;
      const provIDFinal = provID?.replace(" ", "%20");
      // if (val.length === 0) {
      //   this.allLocation = false
      // }
      // this.$store.state.campaign.formCampaign.targeting.locationProvince = val
      if (provIDFinal !== undefined) {
        const headers = {
          Authorization: `Bearer ${this.$store.state.auth.userData.data.accessToken}`,
        };
        axiosIns
          .get(`iohkabupaten/${provIDFinal}`, {
            headers,
          })
          .then((response) => {
            this.optionsKabupaten = response.data.data;
            // resolve(response.data.data.kabupaten)
          })
          .catch((error) => {
            // console.log(error);
          });
        this.$store.state.campaign.formCampaign.targeting.locationProvince = this.provinceSelected;
      }
    },
    inputLocationKabupaten() {
      this.$store.state.campaign.formCampaign.targeting.locationKabupaten = ""
      this.$store.state.campaign.formCampaign.targeting.locationKecamatan = ""
      this.kecamatanSelected = ""
      const kabID = this.kabupatenSelected;
      const kabIDFinal = kabID.replace(" ", "%20");
      // if (val.length === 0) {
      //   this.allLocation = false
      // }
      // this.$store.state.campaign.formCampaign.targeting.locationProvince = val
      const headers = {
        Authorization: `Bearer ${this.$store.state.auth.userData.data.accessToken}`,
      };
      axiosIns
        .get(`iohkecamatan/${kabIDFinal}`, {
          headers,
        })
        .then((response) => {
          this.optionsKecamatan = response.data.data;
          // resolve(response.data.data.bidPrice)
        })
        .catch((error) => {
          // console.log(error);
        });
      this.$store.state.campaign.formCampaign.targeting.locationKabupaten = this.kabupatenSelected;
    },
    inputLocationKecamatan() {
      this.$store.state.campaign.formCampaign.targeting.locationKecamatan = this.kecamatanSelected;
    },
    // END INPUT LOCATION PROVINCE

    // INPUT SEGMENTS SELECTION
    // Persona
    inputUserPersona() {
      this.$store.state.campaign.formCampaign.targeting.selectionSegmentsTargeting.selectionUserPersona = this.userPersonaSelection;
    },
    // End Persona

    // App
    inputApp() {
      this.$store.state.campaign.formCampaign.targeting.selectionSegmentsTargeting.selectionApp = this.appSelection;
    },
    // End App

    // Engagement App
    inputEngagementbyApp() {
      this.$store.state.campaign.formCampaign.targeting.selectionSegmentsTargeting.selectionEngagementbyApp = this.engagementbyAppSelection;
    },
    // End Engagement App

    // Visitor
    inputVisitor() {
      this.$store.state.campaign.formCampaign.targeting.selectionSegmentsTargeting.selectionVisitor = this.visitorSelection;
    },
    // End Visitor

    // Commuter
    inputCommuter() {
      this.$store.state.campaign.formCampaign.targeting.selectionSegmentsTargeting.selectionCommuter = this.commuterSelection;
    },
    // End Commuter

    // Neigbourhood Tier
    inputNeigbourhoodTier() {
      this.$store.state.campaign.formCampaign.targeting.selectionSegmentsTargeting.selectionNeigbourhoodTier = this.neigbourhoodTierSelection;
    },
    // End Neigbourhood Tier

    // POI Category
    inputPOICategory() {
      this.$store.state.campaign.formCampaign.targeting.selectionSegmentsTargeting.selectionPOICategory = this.poiCategorySelection;
    },
    // End POI Category
    // END SEGMENTS SELECTION

    // Circle
    selectedLongLat() {
      let dataLongLat = {
        center: [
          parseFloat(this.longitudeSelected),
          parseFloat(this.latitudeSelected),
        ],
        radius: 1000,
        color: "red",
      };
      this.circle = dataLongLat;
    },
    // Circer

    // Generate Data Visual
    generateDataVisual() {
      this.loadingGetDataVisual = true;
      this.setGetParamsDSV().then(() => {
        this.loadingGetDataVisual = false;
      })
    },
    // End Generate Data Visual

    onChangeRadius() {
      this.frameUsersDSV =
        `${process.env.VUE_APP_URL_DSV_USER_DEFINED_AREA}?params=%7B%22ds122.lat%22:` +
        this.circle.center[0].toString() +
        ",%22ds122.lng%22:" +
        this.circle.center[1].toString() +
        ",%22ds122.radius%22:" +
        this.circle.radius.toString() +
        "%7D";
      this.circle.radius = this.circle.radius;
      this.$store.state.campaign.formCampaign.targeting.circle.radius = this.circle.radius;
    },
  },
};
</script>
<style scoped>
/* SDA AUDIENCE EXPLORATION - Visualization */
.title-SDAAudienceExploration h2 {
  background: #3a3b3c;
  color: white;
  padding: 8px;
  text-align: center;
  font-weight: bold;
}
.radio-visualization input {
  visibility: hidden !important;
}
.radio-visualization label {
  cursor: pointer;
}
.btnTargetAudience {
  background: white !important;
  border: none;
  color: black !important;
  font-weight: bold;
}
.btnTargetAudience:hover {
  box-shadow: none !important;
}
.btnTargetAudience.activeBtn {
  background: #ed1a25 !important;
  color: white !important;
}
/* SDA AUDIENCE EXPLORATION - Visualization */

/* SEGMENT SELECTION & BUSINESS DATA EXPLORATION - Manual */
.title-segmentsSelection,
.title-BusinessDataExploration {
  margin-bottom: 24px;
}
.title-segmentsSelection h2,
.title-BusinessDataExploration h2 {
  background: #c6168d;
  color: white;
  padding: 8px;
  text-align: center;
  font-weight: bold;
}
.lable-segmentsSelection {
  padding: 4px;
  text-align: center;
  border-radius: 4px;
  color: white;
}
.totalSubsSelected {
  margin: 8px 0px;
  margin-bottom: 0 !important;
  padding: 8px 0;
  text-align: center;
  background: #32bcad;
  border-radius: 4px;
}
.totalSubsSelected p {
  margin: 0;
  color: #fff;
}
.titleSubs {
  font-size: 12px;
}
.totalSubs {
  font-weight: bold;
  font-size: 24px;
  padding: 6px 0 2px;
}
/* END SEGMENT SELECTION & BUSINESS DATA EXPLORATION - Manual */

/* CARD TARGET AUDIENCE - Manual */
.card-targetAudience {
  border: 1px solid #cccccc;
  border-radius: 4px;
  padding: 14px;
  margin-bottom: 12px;
}
.btn-cardTargetAudience {
  background: #32bcad;
  color: #fff;
  width: 50%;
}
/* END CARD TARGET AUDIENCE - Manual  */

/* INTEREST */
.btn-addInterest {
  background: #ffcb05 !important;
  border-color: #ffcb05 !important;
}
.btn-addInterest:hover {
  box-shadow: 0 8px 25px -8px #ffcb05 !important;
}
/* END INTEREST - Manual */

/* MAP - Manual */
.title-map {
  font-weight: 900;
  font-size: 16px;
  line-height: 21px;
  color: #5e5873;
}
.maps {
  position: absolute;
  z-index: 999;
  right: 14px;
  flex-direction: column;
}
.btn-map {
  margin: 4px 0;
  background: white !important;
  color: black !important;
  border: none;
  border-radius: 8px;
}
/* MAP - Manual */
</style>
